import { BACKEND_API_URL } from "./app";

// Stripe keys are now ONLY in the Python backend - never in client-side code
export const DIAGNOSTICS_API_URL = process.env.REACT_APP_DIAGNOSTICS_API_URL || "http://localhost:8000";
export const AVATAR_PAYMENT_AMOUNT = 300; // $3.00 in cents
export const DIET_CONSULTATION_AMOUNT = 30000; // $300.00 in cents
export const ZOG_CONSULTATION_AMOUNT = 30000; // $300.00 in cents

export const AVATAR_PAYMENT_API_URL = `${BACKEND_API_URL}/api/payment/avatar/create-checkout`;
